import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import instance from '../../../utils/axios';

export const fetchSportsEvents = createAsyncThunk(
    'sports/fetchEvents',
    async (_, { rejectWithValue }) => {
        try {
            const response = await instance.get('/api/event/all');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch sports events');
        }
    }
);

const sportsSlice = createSlice({
    name: 'sports',
    initialState: {
        events: [],
        cricketEvents: [],
        soccerEvents: [],
        tennisEvents: [],
        cricketLiveEvents: [],
        soccerLiveEvents: [],
        tennisLiveEvents: [],
        loading: false,
        error: null
    },
    reducers: {
        clearEvents(state) {
            state.events = [];
            state.cricketEvents = [];
            state.soccerEvents = [];
            state.tennisEvents = [];
            state.cricketLiveEvents = [];
            state.soccerLiveEvents = [];
            state.tennisLiveEvents = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSportsEvents.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSportsEvents.fulfilled, (state, action) => {
                state.loading = false;
                state.events = action.payload.data || [];

                state.cricketEvents = state.events.filter(
                    event => event.event_type === 4 || event.event_type === '4'
                );
                state.soccerEvents = state.events.filter(
                    event => event.event_type === 1 || event.event_type === '1'
                );
                state.tennisEvents = state.events.filter(
                    event => event.event_type === 2 || event.event_type === '2'
                );
                state.cricketLiveEvents = state.events.filter(
                    event => event.is_inplay == 'True' && event.event_type == 4
                );
                state.soccerLiveEvents = state.events.filter(
                    event => event.is_inplay == 'True' && event.event_type == 1
                );
                state.tennisLiveEvents = state.events.filter(
                    event => event.is_inplay == 'True' && event.event_type == 2
                );


            })
            .addCase(fetchSportsEvents.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch events';
                state.events = [];
                state.cricketEvents = [];
                state.soccerEvents = [];
                state.tennisEvents = [];
                state.cricketLiveEvents = [];
                state.soccerLiveEvents = [];
                state.tennisLiveEvents = [];
            });
    }
});

export const { clearEvents, filterEvents } = sportsSlice.actions;

export default sportsSlice.reducer;